var exports = {
  "I": "ConflictsSectionLoadingSpinner__nx3YdE",
};

module.exports = exports;
